import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Title, Form, Panel } from 'components/layout'
import { Select } from 'components/fields'
import { Button, FormButton } from 'components/misc'
import { ActivityDetail } from 'components/sections/activities'
import { form } from 'helpers/decorators'
import { ACTIVITY_SECTIONS, PROGRESS_STATES } from 'constants/enums'
import { injectIntl, FormattedMessage } from 'react-intl'
import { apiActivities, apiAssessors } from 'helpers/decorators/api'
import { validateCreate } from 'models/activities'
import assessorsDropdownSelector from '../../../redux/selectors/assessors/assessorsDropdownSelector'

@apiAssessors()
@apiActivities({
  updateParticipantAward: true
})
@form({
  form: 'addActivity',
  disableHook: true,
  validate: validateCreate
})
@injectIntl
class AddActivityModal extends Component {
  static propTypes = {
    awardId: PropTypes.number,
    handleSubmit: PropTypes.func,
    intl: PropTypes.object,
    modalId: PropTypes.string,
    onCreateActivity: PropTypes.func,
    modal: PropTypes.func,
    values: PropTypes.object,
    reset: PropTypes.func,
    groupedActivities: PropTypes.object,
    isAssessorDetailMandatory: PropTypes.bool,
    isAssessorManagementEnabled: PropTypes.bool,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func,
    orgId: PropTypes.number.isRequired
  }

  getSections = intl => [
    {
      value: ACTIVITY_SECTIONS.physical.id,
      label: intl.formatMessage({
        id: 'award.physical_recreation',
        defaultMessage: 'Physical recreation'
      })
    },
    {
      value: ACTIVITY_SECTIONS.skills.id,
      label: intl.formatMessage({
        id: 'award.skills',
        defaultMessage: 'Skills'
      })
    },
    {
      value: ACTIVITY_SECTIONS.service.id,
      label: intl.formatMessage({
        id: 'award.service',
        defaultMessage: 'Service'
      })
    }
  ]

  handleCreateActivity = fields =>
    this.props
      .onCreateActivity(this.props.awardId, fields)
      .then(() => this.props.reset())
      .catch(console.log)

  render() {
    const {
      modalId,
      groupedActivities,
      handleSubmit,
      values,
      intl,
      isAssessorDetailMandatory,
      isAssessorManagementEnabled,
      onGetAvailableAssessorsForActivityCategory,
      orgId,
      assessors
    } = this.props

    let currentActivities

    let reachedLimit = false

    if (get(values, 'activitySection.value')) {
      currentActivities = groupedActivities[
        values.activitySection.value
        ].filter(
        activity =>
          activity.activityState.value !== PROGRESS_STATES.activityDeleted.id
      )
      reachedLimit = currentActivities && currentActivities.length >= 5
    }

    let assessorList = assessorsDropdownSelector(assessors, this.props)

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.new_activity">
          NEW ACTIVITY
        </Title>
        {reachedLimit && (
          <Panel>
            <FormattedMessage
              tagName="p"
              id="label.reached_activity_limit"
              defaultMessage="Activities limit reached in this activity section. Participant can have maximum of 3 activities in each section."
            />
          </Panel>
        )}
        <Form
          className="form"
          onSubmit={handleSubmit(this.handleCreateActivity)}
        >
          <div className="row" />
          <Select
            label="Activity Section"
            intlKey="label.activity_section"
            name="activitySection.value"
            options={this.getSections(intl)}
          />
          <ActivityDetail
            {...this.props}
            section={get(values, 'activitySection.value')}
            noTitle
            isAssessorDetailMandatory={isAssessorDetailMandatory}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            onGetAvailableAssessorsForActivityCategory={onGetAvailableAssessorsForActivityCategory}
            assessorList={assessorList}
            orgId={orgId}
          />
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.cancel"
                onClick={() => this.props.modal(null)}
                secondary
                type="button"
                style={{ marginRight: 10 }}
              >
                Cancel
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <FormButton
                {...this.props}
                intlKey="button.create"
                disabled={reachedLimit}
              >
                Create
              </FormButton>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default AddActivityModal
